export default __webpack_public_path__ + "static/media/9.445b6314.png";